import * as React from 'react'
import ReactLoader from 'react-loader-spinner'

import colors from '../../themes/Colors'
import { Mobile, TabletOrDesktop } from '../../utils/ResponsiveUtils'

interface LoaderProps {
   height?: number
   width?: number
   type?: string
   color?: string
   className?: string
   [x: string]: any
}

const mobileMaximumLoaderRadius = 40
class Loader extends React.Component<LoaderProps> {
   static defaultProps = {
      type: 'Oval',
      color: colors.primaryColor,
      height: 30,
      width: 30
   }

   render() {
      const { height, width, type, color, className, ...other } = this.props
      return (
         <>
            <Mobile>
               <ReactLoader
                  type={type}
                  width={Math.min(width as number, mobileMaximumLoaderRadius)}
                  height={Math.min(height as number, mobileMaximumLoaderRadius)}
                  color={color}
                  {...other}
               />
            </Mobile>

            <TabletOrDesktop>
               <ReactLoader
                  type={type}
                  width={width}
                  height={height}
                  color={color}
                  {...other}
               />
            </TabletOrDesktop>
         </>
      )
   }
}

export default Loader
